<template>
    <v-container fluid class="pt-0">
        <v-row align="start" justify="center">
            <v-col cols="12" md="12" sm="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        <v-row>
                            <v-col cols="3" sm="3" md="3" class="">
                                Event List
                            </v-col>

                            <v-col cols="4" sm="4" md="4" class="text-center">
                                <v-btn @click="addRetailItem(business)" color="primary "  fab x-small dark class="mr-1" title="Add Retail Item">
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                                 <v-btn @click="addFoodItem(business)" color="primary "  fab x-small dark class="mr-1" title="Add Food Item"><v-icon>mdi-food</v-icon></v-btn>
                                 <v-btn @click="addDrinkItem(business)" color="primary "  fab x-small dark class="mr-1" title="Add Drink Item"><v-icon>mdi-glass-mug</v-icon></v-btn>

                                 <v-btn @click="addEmployee(business)" color="primary "  fab x-small dark class="mr-1" title="Add Employee"><v-icon>mdi-account-tie</v-icon></v-btn>

                                <v-btn @click="addDepartment(business)" color="primary "  fab x-small dark class="mr-1" title="Add Department">
                                     <v-icon>mdi-desktop-mac</v-icon>
                                </v-btn> 
                                          
                                 <!-- <v-btn @click="addEvent(id)" color="primary " fab x-small dark class="mr-1" title="Add Event"><v-icon>mdi-calendar-plus</v-icon></v-btn> -->

                                <v-btn @click="editBusiness(business)" color="primary "  fab x-small dark class="mr-1" title="Business Edit">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn> 

                            </v-col>

                            <v-col cols="5" sm="5" md="5" class="text-center">
                                <v-row>
                                    <v-col cols="6" sm="6" md="6" class="text-center pt-0">       
                       
                                        <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="6" class="text-center pt-0">    
                                        <v-btn color="primary" class="ml-3" @click="$router.push({name:'createevent',params:{business:business}})">Add Event</v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>            
                    </v-card-title>
                    <v-card-text>
                        <v-divider></v-divider>
                        <h3 class="mb-3 mt-3">Business: {{businessname}}</h3>

                        <v-tabs background-color="transparent" color="#FE5800"  grow>
                            <v-tab href="#tab-selfevent" key="1" span >Self Events</span></v-tab>
                            <v-tab href="#tab-shareevent" key="2" span >Shared Events</span></v-tab>
                            <v-tab href="#tab-availableshareevent" key="2" span >Available Shared Events</span></v-tab>

                            <v-tab-item class="pb-80" key="1" value="tab-selfevent">
                                <v-data-table
                                    :headers="headers"
                                    :items="events"
                                    :items-per-page="20"
                                    :search="search"
                                    class="elevation-1">

                                    <template v-slot:item.title="{ item }">
                                    
                                     <span v-html="item.title"></span>
                                    </template>

                                    <template v-slot:item.action="{ item }">
                                                                    <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                                        <v-icon small @click="deleteItem(item)">delete</v-icon>
                                    </template>

                                </v-data-table>
                            </v-tab-item>   

                            <v-tab-item class="pb-80" key="2" value="tab-shareevent">
                                    <v-data-table
                                    :headers="sharedheaders"
                                    :items="sharedevents"
                                    :items-per-page="20"
                                    :search="sharedsearch"
                                    class="elevation-1">

                                    <template v-slot:item.title="{ item }">
                                    
                                    <span v-html="item.title"></span>
                                    </template>

                                    <template v-slot:item.action="{ item }">
                                        <v-icon small @click="deleteSharedItem(item)">delete</v-icon>
                                    </template>

                                </v-data-table>
                            </v-tab-item>     

                            <v-tab-item class="pb-80" key="2" value="tab-availableshareevent">
                                <v-data-table
                                    :headers="availableheaders"
                                    :items="availablesharedevents"
                                    :items-per-page="20"
                                    :search="availablesearch"
                                    class="elevation-1">

                                    <template v-slot:item.title="{ item }">
                                    <!-- <v-avatar @click="editItem(item)" class="">
                                        <img :src="item.image" :alt="item.title" />
                                    </v-avatar> -->
                                    <!-- <v-img :src="item.image" width="35" height="35" :alt="item.image" ></v-img>  -->
                                    <span v-html="item.title"></span>
                                    </template>

                                    <template v-slot:item.action="{ item }">
                                        <v-menu top :close-on-click="closeOnClick" style="background:#fff;" width="400">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                color="primary"
                                                dark
                                                v-on="on"
                                                >
                                                Add Event
                                                </v-btn>
                                            </template>

                                            <v-list height="250" width="200">
                                                <v-list-item
                                                v-for="(eventtypeitem, eventtypeindex) in eventtypes"
                                                :key="eventtypeindex"
                                                @click="seteventype(eventtypeitem.id,item.id)"
                                                z-index="99999"
                                                style="backgroung-color:#fff;"
                                                >
                                                <v-list-item-title>{{ eventtypeitem.name }}</v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                </v-data-table>
                            </v-tab-item>

                        </v-tabs>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script >
import Vue from 'vue'

export default {
    data: () => ({
        search: "",
        headers: [
            { text: "Title", value: "title" },
            { text: "Event Type", value: "eventtypename" },
            { text: "Time", value: "time" },
            { text: "Start Date", value: "startdate" },
            { text: "End Date", value: "enddate" },
            { text: "Created At", value: "created_at" },
            { text: "Actions", value: "action", sortable: false }
        ],
        events: [],
        business:0,
        businessname:'',

        availablesharedevents:[],
        availableheaders: [
           
            {text:"Business Name",value:"business"},
            { text: "Title", value: "title" },
            { text: "Time", value: "time" },
            { text: "Start Date", value: "startdate" },
            { text: "End Date", value: "enddate" },
            { text: "Actions", value: "action", sortable: false }
        ],

        

        eventtypes:[],

        sharedevents:[],
        sharedheaders: [
           
            {text:"Business Name",value:"business"},
            { text: "Event Type", value: "eventtypename" },
            { text: "Title", value: "title" },
            { text: "Time", value: "time" },
            { text: "Start Date", value: "startdate" },
            { text: "End Date", value: "enddate" },
            { text: "Actions", value: "action", sortable: false }
        ],

    }),
    created() {

        if (this.$route.params.business_id) 
        {
            this.business = this.$route.params.business_id;
        }
      
        this.$http
        .get(this.$apidomain+"agent/eventList/"+this.business)
        .then(res => {
            if(res.data.success==0)
            {
              this.$router.push({name:'businesslistnew'});
            }
            this.events = res.data.events;
            this.businessname=res.data.bname;
        })
        .catch(err => {
            console.log(err.response);
        });

        this.$http
        .get(this.$apidomain+"agent/availablesharedevents/"+this.business)
        .then(res => {
            if(res.data.success==0)
            {
              this.$router.push({name:'businesslistnew'});
            }
                this.availablesharedevents = res.data.events;
       
        })
        .catch(err => {
            console.log(err.response);
        });

        this.$http
        .get(this.$apidomain+"eventtypelist")
        .then(res => {
            if(res.data.success==0)
            {
              this.$router.push({name:'businesslistnew'});
            }
            this.eventtypes = res.data.eventtype;
        })
        .catch(err => {
            console.log(err.response);
        }); 

        this.$http
        .get(this.$apidomain+"sharedevents/"+this.business)
        .then(res => {
            this.sharedevents = res.data.events;
       
        })
        .catch(err => {
            console.log(err.response);
        });
    },
     methods: 
     {
        editBusiness(id)
        {
            this.$router.push({name:'editbusiness',params:{id:id}});
        },

        addRetailItem(id)
        {
            this.$router.push({name:'retailitemlist',params:{business_id:id}});
        },
        
        addFoodItem(id)
        {
                //this.$router.push({name:'createitem',params:{business_id:id}});
            this.$router.push({name:'itemlist',params:{business_id:id}});
        },
            addDrinkItem(id)
            {
            this.$router.push({name:'drinkitemlist',params:{business_id:id}});
            },
            addEmployee(id)
            {
            this.$router.push({name:'employeelist',params:{business_id:id}});
            },
            addDepartment(id)
            {
            this.$router.push({name:'departmentlist',params:{business_id:id}});
            },
            addEvent(id)
            {
            this.$router.push({name:'eventlist',params:{business_id:id}});
            },
            seteventype(eventtypeid,eventid)
            {
                let th=this;
                this.$http
                .post(this.$apidomain+"addSharedEvent/"+this.business+'/'+eventid+'/'+eventtypeid)
                .then(res => {
                    if(res.data.success)  
                    {
                    this.evlist();
                    }
                })
                .catch(err => {
                    
                    console.log(err.response);
                });
            },
            evlist()
            {
                console.log(this.business);
                this.$router.go();
            },
            editItem(item){
                this.$router.push({name:'editevent',params:{id:item.id}});
            },
            deleteItem(item) 
            {
                
                if (confirm("Are you sure you want to delete this Event?")) 
                {
                        this.$http
                    .post(this.$apidomain+"eventDelete/"+item.id)
                    .then(res => {
                        // //this.businesses = res.data.businesses;
                        // this.$router.push("/itemlist/"+this.business);
                        this.$http
                    .get(this.$apidomain+"eventList/"+this.business)
                    .then(res => {
                    this.events = res.data.events;
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                }
            },
            deleteSharedItem(item)
            {
                if (confirm("Are you sure you want to delete this Shared Event?")) 
                {
                    this.$http
                    .post(this.$apidomain+"deletesharedevent/"+this.business+'/'+item.id)
                    .then(res => {
                    this.$router.go();
                    })
                    .catch(err => {
                        console.log(err.response);
                    });
                }
            }
   
  }
    
}
</script>
<style >
.v-application p {
	margin-bottom: 0px;
}
</style>